module.exports = __webpack_public_path__ + "072b9baa70ce144b0fd1d8c87c4bc0c1.pdf";